import { useState } from "react";
import { api } from "@/lib/api";
import { Star } from "lucide-react";
import { toast } from "sonner";

const LABELS = ["", "Unusable", "Poor", "OK", "Good", "Crystal clear"];

export function RateCallCard({ matchId, meta, onDone }) {
  const [stars, setStars] = useState(0);
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      await api.post(`/matches/${matchId}/call/rate`, { stars, comment: comment || null, ...meta });
      toast.success("Thanks — that helps us tune cross-border calls");
    } catch { toast.error("Couldn't save your rating"); }
    finally { setBusy(false); onDone(); }
  };

  const shown = hover || stars;
  return (
    <div data-testid="rate-call-card" className="glass rounded-3xl p-6 w-full max-w-sm text-center pop">
      <p className="text-[11px] uppercase tracking-widest text-amber-400/80">Quick one</p>
      <h3 className="font-display font-black text-xl mt-1">How was the call quality?</h3>
      <div className="flex justify-center gap-1.5 mt-4" onMouseLeave={() => setHover(0)}>
        {[1, 2, 3, 4, 5].map((n) => (
          <button key={n} data-testid={`rate-star-${n}`} onMouseEnter={() => setHover(n)} onClick={() => setStars(n)}
            className="p-1 transition-transform hover:scale-110 active:scale-95" aria-label={`${n} stars`}>
            <Star className={`h-9 w-9 transition-colors ${n <= shown ? "fill-amber-400 text-amber-400" : "text-white/25"}`} />
          </button>
        ))}
      </div>
      <p data-testid="rate-label" className="text-sm text-slate-300 h-5 mt-1">{LABELS[shown]}</p>
      {stars > 0 && (
        <textarea data-testid="rate-comment" value={comment} onChange={(e) => setComment(e.target.value)} maxLength={300} rows={2}
          placeholder="Anything off? Lag, echo, low volume… (optional)"
          className="w-full mt-3 rounded-2xl bg-white/5 border border-white/10 px-4 py-2.5 text-sm outline-none focus:border-amber-400/40 resize-none" />
      )}
      <div className="flex gap-2 mt-4">
        <button data-testid="rate-skip" onClick={onDone} className="flex-1 h-11 rounded-full border border-white/15 text-sm text-slate-300 hover:bg-white/5">Skip</button>
        <button data-testid="rate-submit" onClick={submit} disabled={!stars || busy} className="flex-1 h-11 rounded-full btn-gold text-sm font-semibold disabled:opacity-50">Send</button>
      </div>
    </div>
  );
}
